import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Sparkles, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../routes";
import { tutorialUrl } from "./tutorialUrl";

export const WELCOME_DISMISSED_KEY = "tp-onboarding-welcome-dismissed";

/**
 * First thing a fresh organization (no members, no sessions) sees on the dashboard:
 * paste the list into the AI import, or watch the tutorial. The checklist decides
 * when it shows and remembers the dismissal under WELCOME_DISMISSED_KEY.
 */
const OnboardingWelcomeCard: React.FC<{ onDismiss: () => void }> = ({ onDismiss }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-grey-10 dark:text-grey-90">{t("onboarding.welcome.title")}</h3>
        <button
          type="button"
          onClick={onDismiss}
          aria-label={t("onboarding.dismiss")}
          className="rounded-md p-1 text-grey-30 hover:bg-grey-95 dark:text-grey-70 dark:hover:bg-primary-20"
        >
          <X size={18} />
        </button>
      </div>
      <p className="mt-1 text-sm text-grey-30 dark:text-grey-70">{t("onboarding.welcome.aiLead")}</p>
      <div className="mt-4 flex flex-wrap items-center gap-4">
        <Link to={ROUTES.ASSISTANT_IMPORT} className="btn btn-primary">
          <Sparkles size={18} />
          <span>{t("onboarding.welcome.aiAction")}</span>
        </Link>
        <a
          href={tutorialUrl(i18n.language)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm font-medium text-primary-40 hover:underline dark:text-primary-90"
        >
          <BookOpen size={16} className="shrink-0" />
          <span>{t("onboarding.tutorialLink")}</span>
        </a>
      </div>
    </div>
  );
};

export default OnboardingWelcomeCard;
